import ActiveLinesAndAgents from "../../../components/dashboards/ActiveLinesAndAgents";
import FilteredAnalytics from "../../../components/dashboards/FilteredAnalytics";
import SelectLineAndDate from "../../../components/dashboards/SelectLineAndDate";
import TripsSalesAnalytics from "../../../components/dashboards/TripsSalesAnalytics";
import { Navigate } from "react-router-dom";
import useUser from "../../../hooks/useUser";

// A driver's account that can only scan lands on the scanner, not on the sales dashboard.
const isScanOnly = (permissions: string[]) =>
  permissions.length > 0 && permissions.every((permission) => permission === "reservation.ticket.scan");

const OperatorsDashboard = () => {
  const { permissions = [] } = useUser();
  if (isScanOnly(permissions)) return <Navigate to="/scan" replace />;
  return (
    <div className="flex flex-col-reverse md:flex-col gap-6">
      <ActiveLinesAndAgents />
      {/* <LineSalesAnalytics /> */}
      <div>
      <SelectLineAndDate />
      <div className="flex flex-col md:flex-row justify-between gap-5">
        <TripsSalesAnalytics />
        <FilteredAnalytics />
      </div>
      </div>
      {/* <div className=" flex flex-col md:flex-row gap-5">
            <TicketsToBePaidOnBusAnalytics />
            <AgentSalesAnalytics />
            <OfficeAndOnlineSalesAnalytics />
          </div>
      <BundleAnalytics /> */}
    </div>
  );
};

export default OperatorsDashboard;
